import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, browserSessionPersistence, setPersistence, inMemoryPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Set persistence with fallback mechanism
const initializeAuthPersistence = async () => {
  try {
    // Try local persistence first (uses IndexedDB)
    await setPersistence(auth, browserLocalPersistence);
    console.log('Auth persistence: Local (IndexedDB)');
  } catch (error) {
    console.warn('Failed to set local persistence, trying session persistence:', error);
    try {
      // Fallback to session persistence (uses sessionStorage)
      await setPersistence(auth, browserSessionPersistence);
      console.log('Auth persistence: Session (sessionStorage)');
    } catch (sessionError) {
      console.warn('Failed to set session persistence, using in-memory:', sessionError);
      try {
        // Last fallback to in-memory persistence
        await setPersistence(auth, inMemoryPersistence);
        console.log('Auth persistence: In-Memory (no persistence)');
      } catch (memoryError) {
        console.error('All persistence methods failed:', memoryError);
      }
    }
  }
};

// Initialize persistence
initializeAuthPersistence();

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

export default app;
